import { render, staticRenderFns } from "./FixTxForm.vue?vue&type=template&id=5fdd768d&"
import script from "./FixTxForm.vue?vue&type=script&lang=js&"
export * from "./FixTxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports